import { Info } from "lucide-react";
import { cn } from "@/lib/utils";

export function InfoBanner({
  children,
  variant = "info",
  title,
  label,
  className,
}: {
  children: React.ReactNode;
  variant?: "info" | "warning" | "danger" | "success";
  title?: string;
  label?: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "mb-4 flex items-start gap-2.5 rounded px-3.5 py-2.5",
        variant === "info" && "border border-info-border bg-info-soft text-info",
        variant === "warning" && "border border-warning-border bg-warning-soft text-warning",
        variant === "danger" && "border border-danger-border bg-danger-soft text-danger",
        variant === "success" && "border border-success-border bg-success-soft text-success",
        className
      )}
    >
      <Info className="mt-0.5 size-4 shrink-0" aria-hidden />
      <div className="text-xs leading-relaxed">
        {label && <div className="mb-0.5 text-xs font-bold text-muted">{label}</div>}
        {title && <div className="mb-0.5 text-xs font-bold">{title}</div>}
        {children}
      </div>
    </div>
  );
}